export const products = [
  {
    id: "001",
    company: "Ray-Ban",
    color: "Gold",
    reviews: 200,
    prevPrice: 100,
    title: "Fancy Sunglasses",
    stars: 4.7,
    newPrice: 129.99,
    category: "Fancy",
    images: [
      {
        src: "https://i.pinimg.com/564x/87/b9/a3/87b9a35074d4dd38552189a2c6515c3b.jpg",
        description: "Elegant gold sunglasses - front view",
      },
    ],
  },
  {
    id: "001a",
    company: "Ray-Ban",
    color: "Gold",
    reviews: 200,
    prevPrice: 100,
    title: "Fancy Sunglasses",
    stars: 4.7,
    newPrice: 129.99,
    category: "Fancy",
    images: [
      {
        src: "https://i.pinimg.com/564x/09/27/51/0927517d1c1d9d4e014079000041feda.jpg",
        description: "Gold sunglasses with clear lenses",
      },
    ],
  },
  {
    id: "001b",
    company: "Ray-Ban",
    color: "Gold",
    reviews: 200,
    prevPrice: 100,
    title: " Gold Sunglasses",
    stars: 4.7,
    newPrice: 129.99,
    category: "Fancy",
    images: [
      {
        src: "https://i.pinimg.com/736x/be/4a/e0/be4ae07ae9f850826604b3cddefafa26.jpg",
        description: "Gold sunglasses - side profile",
      },
    ],
  },
  {
    id: "001c",
    company: "Ray-Ban",
    color: "Gold",
    reviews: 200,
    prevPrice: 100,
    title: "Fancy Sunglasses",
    stars: 4.7,
    newPrice: 129.99,
    category: "Fancy",
    images: [
      {
        src: "https://i.pinimg.com/736x/04/fc/7a/04fc7adc4c516aee249f1ce368ea08d1.jpg",
        description: "Gold sunglasses - on model",
      },
    ],
  },

  {
    id: "001d",
    company: "Ray-Ban",
    color: "Gold",
    reviews: 200,
    prevPrice: 100,
    title: "Gold Sunglasses",
    stars: 4.7,
    newPrice: 129.99,
    category: "Fancy",
    images: [
      {
        src: "https://i.pinimg.com/564x/64/f3/53/64f3534e7ed2d46980df4fb1571a4521.jpg",
        description: "Gold sunglasses - close-up",
      },
    ],
  },
  {
    id: "001e",
    company: "Ray-Ban",
    color: "Gold",
    reviews: 200,
    prevPrice: 100,
    title: " Gold Sunglasses",
    stars: 4.7,
    newPrice: 129.99,
    category: "Fancy",
    images: [
      {
        src: "https://i.pinimg.com/736x/ac/44/e9/ac44e901deb3f8c6866abc6bc58439ff.jpg",
        description: "Gold sunglasses - with different lens",
      },
    ],
  },
  {
    id: "001f",
    company: "Ray-Ban",
    color: "Gold",
    reviews: 200,
    prevPrice: 100,
    title: "Fancy Sunglasses",
    stars: 4.7,
    newPrice: 129.99,
    category: "Fancy",
    images: [
      {
        src: "https://i.pinimg.com/736x/bc/46/45/bc46457669f9d03491718501a698eef0.jpg",
        description: "Gold sunglasses - angled view",
      },
    ],
  },
  {
    id: "002",
    company: "Chanel",
    color: "Black",
    reviews: 150,
    prevPrice: 109.99,
    title: "Modern Sunglasses",
    stars: 4.5,
    newPrice: 99.99,
    category: "Modern",
    images: [
      {
        src: "https://i.pinimg.com/736x/67/00/78/670078c39458c78d781ebd3fe511b9d6.jpg",
        description: "Black sunglasses - front view",
      },
    ],
  },
  {
    id: "002a",
    company: "Chanel",
    color: "Black",
    reviews: 150,
    prevPrice: 109.99,
    title: "Black Sunglasses",
    stars: 4.5,
    newPrice: 99.99,
    category: "Modern",
    images: [
      {
        src: "https://i.pinimg.com/564x/4b/1b/dd/4b1bdd7861616444fb61218888e7cd94.jpg",
        description: "Black sunglasses with glossy finish",
      },
    ],
  },
  {
    id: "002b",
    company: "Chanel",
    color: "Black",
    reviews: 150,
    prevPrice: 109.99,
    title: "Black Sunglasses",
    stars: 4.5,
    newPrice: 99.99,
    category: "Modern",
    images: [
      {
        src: "https://i.pinimg.com/564x/3c/6a/64/3c6a64369b7a40eb334b703e91b7bc3b.jpg",
        description: "Black sunglasses - side view",
      },
    ],
  },
  {
    id: "002c",
    company: "Chanel",
    color: "Black",
    reviews: 150,
    prevPrice: 109.99,
    title: "Modern Sunglasses",
    stars: 4.5,
    newPrice: 99.99,
    category: "Modern",
    images: [
      {
        src: "https://i.pinimg.com/564x/f1/9d/81/f19d8100adf6672fcd1bdd60568c4ee7.jpg",
        description: "Black sunglasses - on model",
      },
    ],
  },
  {
    id: "003",
    company: "Gucci",
    color: "Yellow",
    reviews: 120,
    prevPrice: 100,
    title: "Bright Sunglasses",
    stars: 4.6,
    newPrice: 50,
    category: "Punk",
    images: [
      {
        src: "https://i.pinimg.com/736x/31/3c/bd/313cbdb326fd079a203a29d64957e620.jpg",
        description: "Yellow sunglasses - front view",
      },
    ],
  },
  {
    id: "003a",
    company: "Gucci",
    color: "Yellow",
    reviews: 120,
    prevPrice: 100,
    title: " Yellow Sunglasses",
    stars: 4.6,
    newPrice: 50,
    category: "Punk",
    images: [
      {
        src: "https://i.pinimg.com/736x/b2/92/8b/b2928b70ea9ebc31f0a7a2c183743499.jpg",
        description: "Yellow sunglasses with gradient lenses",
      },
    ],
  },
  {
    id: "003b",
    company: "Gucci",
    color: "Yellow",
    reviews: 120,
    prevPrice: 100,
    title: " Bold Sunglasses",
    stars: 4.6,
    newPrice: 50,
    category: "Punk",
    images: [
      {
        src: "https://i.pinimg.com/736x/56/9f/79/569f79b3c192ed481cdc776fa15e8883.jpg",
        description: "Yellow sunglasses - side profile",
      },
    ],
  },
  {
    id: "003c",
    company: "Gucci",
    color: "Yellow",
    reviews: 120,
    prevPrice: 100,
    title: " Yellow Sunglasses",
    stars: 4.6,
    newPrice: 119.99,
    category: "Punk",
    images: [
      {
        src: "https://i.pinimg.com/736x/29/d9/74/29d9742231af7f5cc5911c752cf4e83b.jpg",
        description: "Yellow sunglasses - on model",
      },
    ],
  },
  {
    id: "003d",
    company: "Gucci",
    color: "Yellow",
    reviews: 120,
    prevPrice: 100,
    title: "Yellow Sunglasses",
    stars: 4.6,
    newPrice: 119.99,
    category: "Punk",
    images: [
      {
        src: "https://i.pinimg.com/564x/d8/cb/39/d8cb397b76fc53e6e461d6c244e25763.jpg",
        description: "Yellow sunglasses - close-up",
      },
    ],
  },
  {
    id: "003e",
    company: "Gucci",
    color: "Yellow",
    reviews: 120,
    prevPrice: 100,
    title: "Yellow Sunglasses",
    stars: 4.6,
    newPrice: 119.99,
    category: "Punk",
    images: [
      {
        src: "https://i.pinimg.com/564x/86/d7/ab/86d7abd30e2ab06c0f1f458b49c43238.jpg",
        description: "Yellow sunglasses - alternative view",
      },
    ],
  },
  {
    id: "004",
    company: "Dior",
    color: "Transparent",
    reviews: 80,
    prevPrice: 149.99,
    title: "Chic glasses",
    stars: 4.4,
    newPrice: 100,
    category: "Simple",
    images: [
      {
        src: "https://i.pinimg.com/736x/6d/dd/38/6ddd381abb86e0d1e60f1298a41600a4.jpg",
        description: "Transparent sunglasses - front view",
      },
    ],
  },
  {
    id: "004a",
    company: "Dior",
    color: "Transparent",
    reviews: 80,
    prevPrice: 149.99,
    title: "Square Shape",
    stars: 4.4,
    newPrice: 100,
    category: "Simple",
    images: [
      {
        src: "https://i.pinimg.com/736x/55/4c/d0/554cd033418b5a24403b94c403d041eb.jpg",
        description: "Transparent sunglasses - side view",
      },
    ],
  },
  {
    id: "005",
    company: "Oakley",
    color: "Blue",
    reviews: 100,
    prevPrice: 50.99,
    title: " Blue Sunglasses",
    stars: 4.6,
    newPrice: 109.99,
    category: "Modern",
    images: [
      {
        src: "https://i.pinimg.com/564x/9c/06/b4/9c06b438fb7bce5c5c98d0edfea36225.jpg",
        description: "Blue sunglasses - front view",
      },
    ],
  },

  {
    id: "006",
    company: "Ray-Ban",
    color: "Orange",
    reviews: 90,
    prevPrice: 50.99,
    title: "Sphere Shape",
    stars: 4.5,
    newPrice: 109.99,
    category: "Punk",
    images: [
      {
        src: "https://i.pinimg.com/736x/d7/0e/c4/d70ec460db92f49991bac0917dee8a88.jpg",
        description: "Orange sunglasses - front view",
      },
    ],
  },
  {
    id: "006a",
    company: "Ray-Ban",
    color: "Orange",
    reviews: 90,
    prevPrice: 50.99,
    title: "Orange Specs",
    stars: 4.5,
    newPrice: 109.99,
    category: "Punk",
    images: [
      {
        src: "https://i.pinimg.com/564x/aa/03/42/aa034242a0eb041aa70e355092e634a8.jpg",
        description: "Orange sunglasses - side view",
      },
    ],
  },
  {
    id: "006b",
    company: "Ray-Ban",
    color: "Orange",
    reviews: 90,
    prevPrice: 50.99,
    title: "Orange Sunglass",
    stars: 4.5,
    newPrice: 109.99,
    category: "Punk",
    images: [
      {
        src: "https://i.pinimg.com/564x/3d/05/b1/3d05b10bad970c2d08c2640b2b067f19.jpg",
        description: "Orange sunglasses - with gradient lenses",
      },
    ],
  },
  {
    id: "006c",
    company: "Ray-Ban",
    color: "Orange",
    reviews: 90,
    prevPrice: 50.99,
    title: "Pop Sunglasses",
    stars: 4.5,
    newPrice: 109.99,
    category: "Punk",
    images: [
      {
        src: "https://i.pinimg.com/564x/17/d6/c0/17d6c07dacda1f075baac384ec6f1257.jpg",
        description: "Orange sunglasses - on model",
      },
    ],
  },
  {
    id: "007",
    company: "Chanel",
    color: "Red",
    reviews: 160,
    prevPrice: 159.99,
    title: "Bold Glasses",
    stars: 4.8,
    newPrice: 149.99,
    category: "Fancy",
    images: [
      {
        src: "https://i.pinimg.com/564x/af/34/43/af34439556a9a9113739e8297f1a275b.jpg",
        description: "Red sunglasses - front view",
      },
    ],
  },
  {
    id: "007a",
    company: "Chanel",
    color: "Red",
    reviews: 160,
    prevPrice: 159.99,
    title: "Red Sunglasses",
    stars: 4.8,
    newPrice: 149.99,
    category: "Fancy",
    images: [
      {
        src: "https://i.pinimg.com/564x/ae/0a/43/ae0a4375418085e8be8e54f53df80aad.jpg",
        description: "Red sunglasses - side view",
      },
    ],
  },
  {
    id: "007b",
    company: "Chanel",
    color: "Red",
    reviews: 160,
    prevPrice: 159.99,
    title: "Red Sunglasses",
    stars: 4.8,
    newPrice: 149.99,
    category: "Fancy",
    images: [
      {
        src: "https://i.pinimg.com/736x/56/9b/90/569b90e940cec8d34831ce78b1741c12.jpg",
        description: "Red sunglasses - with gradient lenses",
      },
    ],
  },
  {
    id: "007c",
    company: "Chanel",
    color: "Red",
    reviews: 160,
    prevPrice: 159.99,
    title: "Red Sunglasses",
    stars: 4.8,
    newPrice: 149.99,
    category: "Fancy",
    images: [
      {
        src: "https://i.pinimg.com/736x/82/f4/f4/82f4f4c8e79bb09c8c055d2763e3a3fe.jpg",
        description: "Red sunglasses - on model",
      },
    ],
  },
  {
    id: "008",
    company: "Gucci",
    color: "Green",
    reviews: 110,
    prevPrice: 129.99,
    title: "Stylish Sunglasses.",
    stars: 4.6,
    newPrice: 50.99,
    category: "Modern",
    images: [
      {
        src: "https://i.pinimg.com/564x/c7/19/96/c71996e4f865acaffbb5bab2ea1fdb42.jpg",
        description: "Green sunglasses - front view",
      },
    ],
  },
  {
    id: "008a",
    company: "Gucci",
    color: "Green",
    reviews: 110,
    prevPrice: 129.99,
    title: "Green Sunglasses",
    stars: 4.6,
    newPrice: 119.99,
    category: "Modern",
    images: [
      {
        src: "https://i.pinimg.com/736x/ff/49/75/ff4975cd304b6ed7b54223a506a9db48.jpg",
        description: "Green sunglasses - side profile",
      },
    ],
  },
  {
    id: "008b",
    company: "Gucci",
    color: "Green",
    reviews: 110,
    prevPrice: 129.99,
    title: "Fire Sunglasses",
    stars: 4.6,
    newPrice: 119.99,
    category: "Modern",
    images: [
      {
        src: "https://i.pinimg.com/564x/4a/88/ad/4a88ad6a202d55c275f3cbb7301ed6c9.jpg",
        description: "Green sunglasses - close-up",
      },
    ],
  },
  {
    id: "008c",
    company: "Gucci",
    color: "Green",
    reviews: 110,
    prevPrice: 129.99,
    title: "Green Sunglasses",
    stars: 4.6,
    newPrice: 50,
    category: "Modern",
    images: [
      {
        src: "https://i.pinimg.com/736x/a9/62/63/a96263e5b91cfe8275058a1ac2fcbaea.jpg",
        description: "Green sunglasses - on model",
      },
    ],
  },
  {
    id: "009",
    company: "Oakley",
    color: "Purple",
    reviews: 130,
    prevPrice: 100,
    title: "Purple Sunglasses",
    stars: 4.7,
    newPrice: 129.99,
    category: "Punk",
    images: [
      {
        src: "https://i.pinimg.com/564x/37/3c/c7/373cc753321770054362b65ae69eaa79.jpg",
        description: "Purple sunglasses - front view",
      },
    ],
  },
  {
    id: "009a",
    company: "Oakley",
    color: "Purple",
    reviews: 130,
    prevPrice: 100,
    title: "Purple Sunglasses",
    stars: 4.7,
    newPrice: 129.99,
    category: "Punk",
    images: [
      {
        src: "https://i.pinimg.com/736x/8a/67/89/8a6789ba59536ed5de4cf150e2cdb75d.jpg",
        description: "Purple sunglasses - side view",
      },
    ],
  },
  {
    id: "009b",
    company: "Oakley",
    color: "Purple",
    reviews: 130,
    prevPrice: 100,
    title: "Purple Sunglasses",
    stars: 4.7,
    newPrice: 129.99,
    category: "Punk",
    images: [
      {
        src: "https://i.pinimg.com/736x/96/d4/8c/96d48c210c47bea91007605a0eccc37c.jpg",
        description: "Purple sunglasses - with mirrored lenses",
      },
    ],
  },
  {
    id: "009c",
    company: "Oakley",
    color: "Purple",
    reviews: 130,
    prevPrice: 100,
    title: "Unique Sunglasses",
    stars: 4.7,
    newPrice: 129.99,
    category: "Punk",
    images: [
      {
        src: "https://i.pinimg.com/736x/cd/af/88/cdaf8894e92ebd2f53972ab629fd8383.jpg",
        description: "Purple sunglasses - on model",
      },
    ],
  },
  {
    id: "010b",
    company: "Dior",
    color: "Brown",
    reviews: 140,
    prevPrice: 149.99,
    title: "Elegant Sunglasses",
    stars: 4.6,
    newPrice: 100,
    category: "Simple",
    images: [
      {
        src: "https://i.pinimg.com/564x/aa/b3/26/aab326df7341fb8555c7316d282537cd.jpg",
        description: "Brown sunglasses - front view",
      },
    ],
  },
  {
    id: "010c",
    company: "Dior",
    color: "Brown",
    reviews: 140,
    prevPrice: 149.99,
    title: "Classic Design",
    stars: 4.6,
    newPrice: 139.99,
    category: "Simple",
    images: [
      {
        src: "https://i.pinimg.com/564x/8e/c1/f2/8ec1f2f9fdb98ab8d7a7b6bc93cc2a4f.jpg",
        description: "Brown sunglasses - side profile",
      },
    ],
  },
  {
    id: "010a",
    company: "Dior",
    color: "Brown",
    reviews: 140,
    prevPrice: 149.99,
    title: "Classic Design.",
    stars: 4.6,
    newPrice: 139.99,
    category: "Simple",
    images: [
      {
        src: "https://i.pinimg.com/564x/a8/16/c2/a816c2920bb08fe34ecf2b92f096b495.jpg",
        description: "Brown sunglasses - on model",
      },
    ],
  },
  {
    id: "010b",
    company: "Dior",
    color: "Brown",
    reviews: 140,
    prevPrice: 149.99,
    title: "Elegant Sunglasses",
    stars: 4.6,
    newPrice: 139.99,
    category: "Punk",
    images: [
      {
        src: "https://i.pinimg.com/564x/aa/b3/26/aab326df7341fb8555c7316d282537cd.jpg",
        description: "Brown sunglasses - front view",
      },
    ],
  },
  {
    id: "010c",
    company: "Dior",
    color: "Brown",
    reviews: 140,
    prevPrice: 149.99,
    title: "Classic Design",
    stars: 4.6,
    newPrice: 139.99,
    category: "Punk",
    images: [
      {
        src: "https://i.pinimg.com/564x/8e/c1/f2/8ec1f2f9fdb98ab8d7a7b6bc93cc2a4f.jpg",
        description: "Brown sunglasses - side profile",
      },
    ],
  },
  {
    id: "010a",
    company: "Dior",
    color: "Brown",
    reviews: 140,
    prevPrice: 149.99,
    title: "Punk Design.",
    stars: 4.6,
    newPrice: 139.99,
    category: "Punk",
    images: [
      {
        src: "https://i.pinimg.com/564x/a8/16/c2/a816c2920bb08fe34ecf2b92f096b495.jpg",
        description: "Brown sunglasses - on model",
      },
    ],
  },
  {
    id: "010a",
    company: "Dior",
    color: "Brown",
    reviews: 140,
    prevPrice: 199.99,
    title: "Punk Design 2.",
    stars: 4.6,
    newPrice: 169.99,
    category: "Punk",
    images: [
      {
        src: "https://i.pinimg.com/564x/aa/b3/26/aab326df7341fb8555c7316d282537cd.jpg",
        description: "Brown sunglasses - on model",
      },
    ],
  },
];
